/* unplugin-vue-components disabled */import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import EZUIKit from 'ezuikit-js';
import { LineEchart } from '@/components/page-echarts';
import useStockTrend from './hooks/useStockTrend';
import useMonitorAccessToken from './hooks/useMonitorAccessToken';
export default defineComponent({
  name: 'StockMonitor',
  components: {
    LineEchart: LineEchart
  },
  setup: function setup() {
    var router = useRouter();
    var title = ref('机制砂');
    var playVideo = ref(1); //是否自动播放 1：开启 0：关闭
    var _useMonitorAccessToke = useMonitorAccessToken(),
      _useMonitorAccessToke2 = _slicedToArray(_useMonitorAccessToke, 2),
      accessToken = _useMonitorAccessToke2[0],
      getMonitorAccessTokenAsync = _useMonitorAccessToke2[1];
    var device_serial = ref('D86156262');
    var channel_no = ref('50');
    var params = ref({
      deviceId: ''
    });
    var route = useRoute();
    if (route.params.id) {
      params.value.deviceId = route.params.id;
      title.value = route.params.name;
      // 此处注释不完整，仅供参考。精品砂-机制砂：27，5-10-0-5石子：28，1-2料：26，普砂-净石粉：25，普1-2:22
      if (route.params.id === '1147') {
        channel_no.value = '31';
      }
      if (route.params.id === '4459') {
        channel_no.value = '30';
      }
      if (route.params.id === '4460') {
        channel_no.value = '29';
      }
      if (route.params.id === '1149' || route.params.id === '4599') {
        channel_no.value = '27';
      }
      if (route.params.id === '1150' || route.params.id === '4601') {
        channel_no.value = '28';
      }
      if (route.params.id === '1151' || route.params.id === '4602') {
        channel_no.value = '26';
      }
      if (route.params.id === '1152' || route.params.id === '4600') {
        channel_no.value = '25';
      }
      if (route.params.id === '4458') {
        channel_no.value = '22';
      }
      // if (
      //   ['4599', '4600', '4601', '4602'].includes(route.params.id as string)
      // ) {
      //   channel_no.value = '22'
      // }
    }
    var _useStockTrend = useStockTrend(params),
      _useStockTrend2 = _slicedToArray(_useStockTrend, 2),
      stockTrendData = _useStockTrend2[0],
      getStockTrendAsync = _useStockTrend2[1];
    var stockTrend = computed(function () {
      var list = stockTrendData.value.map(function (item) {
        return item.stone_value;
      });
      var xLabels = stockTrendData.value.map(function (item) {
        return item.stone_time;
      });
      return {
        lineData: list,
        xLabels: xLabels,
        legendData: ['历史库存'],
        yName: '',
        showDetail: true,
        grid: {
          left: '7%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        formatter: function formatter(params) {
          var res = "\n              <div >\n                <div class=\"flex align-center\">\n                  <span class=\"ml-2\">".concat(params[0].axisValue, "</span>\n\n                </div>\n              ");
          params.forEach(function (item) {
            res += "\n                <div >\n                  ".concat(item.marker, "\n                  <span style=\"font-size: 12px;\">").concat(item.seriesName, "</span>\n                  <span style=\"font-weight:bold;font-size: 12px;\">").concat(item.value, "m</span>\n                </div>\n              ");
          });
          res += '</div>';
          return res;
        }
      };
    });
    var back = function back() {
      router.back();
    };
    var player;
    var randomKey = ref(Math.random());
    onMounted( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            getStockTrendAsync();
            _context.next = 3;
            return getMonitorAccessTokenAsync();
          case 3:
            player = new EZUIKit.EZUIKitPlayer({
              audio: 0,
              autoplay: playVideo.value,
              id: "video-container",
              accessToken: accessToken.value,
              url: "ezopen://open.ys7.com/".concat(device_serial.value, "/").concat(channel_no.value, ".hd.live"),
              template: 'simple',
              handleSuccess: function handleSuccess(data) {
                var dom = document.querySelector('.' + data.id);
                if (dom) {
                  dom.className = 'display-none';
                }
              }
            });
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    onBeforeUnmount(function () {
      player.stop().then(function () {
        player.play({
          url: "ezopen://open.ys7.com/".concat(device_serial.value, "/").concat(channel_no.value, ".hd.live")
        });
      });
    });
    return {
      back: back,
      title: title,
      stockTrend: stockTrend,
      channel_no: channel_no,
      randomKey: randomKey
    };
  }
});